@if (displayDialog) {
  <div class="popup"  [ngStyle]="{'top.px': top, 'left.px': left}">
    <div class="popup-content">
      <div style="display: flex;gap: 10px;">
        <div class="calendar-section">
          <p-calendar
            [(ngModel)]="timeFrom"
            [maxDate]="maxFilterDate" dataType="string"
            showTime="isSelectTime"
            hourFormat="24"
            dateFormat="dd-mm-yy"
            [showIcon]="false"
            [inline]="true"
            (onSelect)="selectCalendarFilterFrom()">
          </p-calendar>
        </div>
        <div class="calendar-section">
          <p-calendar
            [(ngModel)]="timeTo"
            [minDate]="minFilterDate" dataType="string"
            showTime="isSelectTime"
            hourFormat="24"
            dateFormat="dd-mm-yy"
            [showIcon]="false"
            [inline]="true"
            (onSelect)="selectCalendarFilterTo()">
          </p-calendar>
        </div>
      </div>
      <div class="calendar-bottom">
        <div class="bt-calendar-bottom">
          <a label="Clear"
          (click)="onClearAction(); $event.stopPropagation()">Clear</a>
        </div>
        <div style="flex: 1;"></div>
        <div class="bt-calendar-bottom">
          <a label="Ok"
          (click)="onOkAction(); $event.stopPropagation()">Ok</a>
        </div>
      </div>
    </div>
  </div>
}